import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-turns-reports-smspicked-card',
  templateUrl: './turns-reports-smspicked-card.component.html',
  styleUrls: ['./turns-reports-smspicked-card.component.scss']
})
export class TurnsReportsSmspickedCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
